import { FileComponentProps } from "../../types";
import { createDataUrl } from "../../utils";
import { FilePreviewWrapper } from "../FilePreviewWrapper";

import { ImageThumbnail } from "./ImageThumbnail";
import { ImagePreview } from "./ImagePreview";

export const ImageDisplay = ({
  data,
  detectedFile,
  isViewing,
  setIsViewing,
}: FileComponentProps) => {
  if (!detectedFile.mimeType) {
    return (
      <div className="flex items-center justify-center rounded p-4">
        <span className="text-gray-500">Unable to display image</span>
      </div>
    );
  }

  const dataUrl = createDataUrl(data, detectedFile.mimeType);

  return (
    <div className="group relative">
      <div className="cursor-pointer rounded p-2">
        <FilePreviewWrapper
          isViewing={isViewing}
          setIsViewing={setIsViewing}
          contentClassName="w-[350px] p-3"
          trigger={
            <div>
              <ImageThumbnail dataUrl={dataUrl} detectedFile={detectedFile} data={data} />
            </div>
          }
        >
          <ImagePreview dataUrl={dataUrl} detectedFile={detectedFile} />
        </FilePreviewWrapper>
      </div>
    </div>
  );
};
